/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2024, Zumper
 */

import { Heading } from '@chakra-ui/react'
import { selectIsBot } from '@zcode-ui/web-zumper-global-state'
import type { MaybeEmptyProperty } from '@zcode/state-type'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectEntity } from '../../../modules/detail/modules/entity/selectors'
import { TelcoWidgetLazyLoadableSection } from './TelcoWidgetLazyLoadableSection'

export const TelcoWrapper = ({ rootMargin }: { rootMargin: string }) => {
  const isBot = useSelector(selectIsBot)
  const entity: MaybeEmptyProperty = useSelector(selectEntity) ?? {}
  const { headerText } = entity

  return (
    <React.Fragment>
      <Heading<'h2'> as="h2" variant="display24To28" my={2}>
        Internet available near {headerText || 'this area'}
      </Heading>
      {!isBot && <TelcoWidgetLazyLoadableSection rootMargin={rootMargin} />}
    </React.Fragment>
  )
}
